
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import isNil from 'lodash/isNil';

import { DEFAULT_PRICELIST } from '../../reducers/data';

import {
    PRICELIST_TYPE_CUSTOM,
    PRICELIST_TYPE_DEFAULT,
    PRICELIST_TYPE_EDIT_DEFAULT,
    PRICELIST_TYPE_FILE,
    getPricelistData,
    getPricelistType,
    getUsekMezItems
} from '../../reducers/project';

import projectGetActions from '../../sagas/project';

import { PAGE_CALC, PAGE_USEK_ATTRS, PAGE_USEK_INPUT, redirectToPage } from '../pagesDefinition';
import SelectPricelistPageView from './SelectPricelistPage.view';
import SelectPricelistType from './SelectPricelistType.state';
import SelectPricelistFromFile from './SelectPricelistFromFile.view';
import PricelistEditor from './PricelistEditor.state';

const SelectPricelistPageState = (props) => {

    const dispatch = useDispatch();
    const projectActions = projectGetActions(dispatch);

    const usekMezItems = useSelector(state => getUsekMezItems(state.project));
    const pricelistData = useSelector(state => getPricelistData(state.project));
    const pricelistType = useSelector(state => getPricelistType(state.project));

    React.useEffect(() => {
        if (!usekMezItems || (usekMezItems.length === 0)) {
            redirectToPage(PAGE_USEK_INPUT);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getCanContinue = () => {
        return !isNil(pricelistType) && !isNil(pricelistData);
    }

    const handleContinueClick = () => {
        projectActions.usePricelistForCalculation();
        redirectToPage(PAGE_CALC);
    }

    const handleGoBackClick = () => {
        redirectToPage(PAGE_USEK_ATTRS);
    }

    const handleSetPricelistType = (pricelistType) => {
        projectActions.setPricelistType(pricelistType);
        switch (pricelistType) {
            case PRICELIST_TYPE_CUSTOM:
                projectActions.usePricelistData(false, {title: 'Vlatní ceník', items:[]});
                break;
            case PRICELIST_TYPE_EDIT_DEFAULT:
                projectActions.usePricelistData(false, DEFAULT_PRICELIST);
                break;
            case PRICELIST_TYPE_DEFAULT:
                projectActions.usePricelistData(true, DEFAULT_PRICELIST);
                break;
            case PRICELIST_TYPE_FILE:
                // nop;
                break;
            default:
                projectActions.usePricelistData(false, null);
                break;
        }
    }

    const handleUploadPricelistFile = (file) => {
        let reader = new FileReader();
        reader.onload = () => {
            let data = reader.result;
            projectActions.readPricelist(data);
        };
        reader.readAsText(file);
    }

    const renderPricelistEditor = () => {
        return (pricelistType && pricelistData)
            ? (
                <PricelistEditor
                    pricelistData={pricelistData}
                />
            )
            : null;
    }

    const renderSelectPricelistFromFile = () => {
        return ((pricelistType === PRICELIST_TYPE_FILE) && (!pricelistData))
            ? (
                <SelectPricelistFromFile
                    onUploadFile={handleUploadPricelistFile}
                />
            )
            : null;
    }

    const renderSelectPricelistType = () => {
        return (
            <SelectPricelistType
                pricelistType={pricelistType}
                onSetPricelistType={handleSetPricelistType}
            />
        );
    }

    return (
        <>
            <SelectPricelistPageView
                canContinue={getCanContinue()}
                onGoBackClick={handleGoBackClick}
                onGoNextClick={handleContinueClick}
                pricelistEditor={renderPricelistEditor()}
                selectFileForPricelist={renderSelectPricelistFromFile()}
                selectPricelistType={renderSelectPricelistType()}
            />
        </>
    );
}

export default SelectPricelistPageState;
